import gql from 'graphql-tag';

export const UPDATE_MYPAGE_MOBILE = gql`
    mutation ($mobile_number: String) {
        memberUpdateMobile(
            mobile_number: $mobile_number
        ){
            result
        }
    },
`;